import React, { useState } from 'react';
import { GetStartedForm } from './GetStartedForm';
export function CTA() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  return <section id="cta" className="bg-black text-white py-16 md:py-24" data-id="element-129">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
        <div className="text-center" data-id="element-131">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-132">
            Ready to transform your business with AI?
          </h2>
          <p className="mt-4 text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-133">
            Join hundreds of businesses already using Agentter.ai to automate
            tasks and improve efficiency.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-134">
            <button onClick={() => setIsFormOpen(true)} className="bg-white text-black px-6 py-3 rounded-lg text-lg font-medium hover:bg-gray-100 transition-colors w-full sm:w-auto" data-id="element-135">
              Start Free Trial
            </button>
            <button onClick={() => setIsFormOpen(true)} className="border border-white text-white px-6 py-3 rounded-lg text-lg font-medium hover:bg-gray-900 transition-colors w-full sm:w-auto" data-id="element-136">
              Schedule Demo
            </button>
          </div>
          <p className="mt-6 text-gray-400" data-id="element-137">
            No credit card required. 14-day free trial.
          </p>
        </div>
      </div>
      {/* Get Started Form */}
      <GetStartedForm isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} data-id="element-138" />
    </section>;
}